// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e3827730","455":"9f527b02","977":"48b1d8c9"}[chunkId] + ".chunk.js";
};